import React, { useEffect } from "react";
import CaseHero from "../commonCase/CaseHero";
import icon from "../../../../assets/svgs/softsidesvg.svg";
import Task from "../commonCase/Task";
import Task1 from "../commonCase/Task1";
import Design from "../commonCase/Design";
import website from "../../../../assets/images/softsideimg.webp";
import Work from "../commonCase/Work";
import work1 from "../../../../assets/images/softsidework1.webp";
import work2 from "../../../../assets/images/softsidework2.webp";
import work3 from "../../../../assets/images/softsidework3.webp";
import work4 from "../../../../assets/images/softsidework4.webp";
import insta from "../../../../assets/svgs/insta 2.svg";
import linkdin from "../../../../assets/svgs/linkdin 2.svg";
import youtube from "../../../../assets/svgs/youtube 2.svg";
import facebook from "../../../../assets/svgs/facebook 2.svg";
import Result from "../commonCase/Result";
import result1 from "../../../../assets/svgs/softsidecard1.svg";
import result2 from "../../../../assets/svgs/softsidecard2.svg";
import result3 from "../../../../assets/svgs/softsidecard3.svg";
import Data from "../../Data";
import OtherProject from "../commonCase/OtherProject";
import tanks from "../../../../assets/svgs/tankssvg.svg";
import aes from "../../../../assets/svgs/aessvg.svg";
import ggp from "../../../../assets/svgs/ggpsvg.svg";

const tableData = [
  { task: "Website Design & Dev", status: true },
  { task: "Social media", status: true },
  { task: "Lead generation", status: true },
];

const task1Data = [
  {
    subheading: "User Experience Analysis: ",
    des: "Reviewed how users navigated the site, identifying confusion points and areas lacking clarity or intent-driven flow.",
  },
  {
    subheading: "Site Speed Optimization: ",
    des: "Worked on backend improvements to reduce load times and create a faster browsing experience across devices.",
  },
  {
    subheading: "Mobile Responsiveness: ",
    des: "Ensured the website functioned seamlessly on all mobile screens, critical for Softside’s wellness-focused, on-the-go audience.",
  },
  {
    subheading: "Product Page Review: ",
    des: "Restructured product sections to better communicate benefits, usage and value - helping users connect emotionally with the offering.",
  },
  {
    subheading: "Checkout Optimization: ",
    des: "Simplified the checkout flow to make purchasing more intuitive, reduce hesitation, and encourage conversions.",
  },
];

const task2Data = [
  {
    subheading: "Content Creation & Scheduling: ",
    des: "Designed engaging, product-focused visuals and managed posting across platforms to maintain a consistent online presence.",
  },
  {
    subheading: "Engagement & Community Building: ",
    des: "Monitored comments, responded to DMs, and interacted with audience feedback to build trust and long-term connection.",
  },
  {
    subheading: "Profile Optimization: ",
    des: "Updated bios, links, and highlights to align with brand goals, drive traffic and improve discovery across all channels.",
  },
  {
    subheading: "Sales-Oriented Messaging: ",
    des: "Crafted captions and creatives that connected the product with real-world use cases, especially useful for premium buyers.",
  },
  {
    subheading: "LinkedIn Lead Positioning: ",
    des: "Handled Derwin Hunt’s professional presence to attract bulk buyers and initiate conversations with high-ticket decision-makers.",
  },
];

const images = [work1, work2, work3, work4];

const linkData = [
  {
    logo: insta,
    link: "https://www.instagram.com/softsidebyhunt/",
    linkName: "Instagram.SoftSideByHunt",
  },
  {
    logo: youtube,
    link: "https://www.youtube.com/@softsidebyhunt",
    linkName: "Youtube.SoftSideByHunt",
  },
  {
    logo: linkdin,
    link: "https://www.linkedin.com/company/soft-side/posts/",
    linkName: "Linkdin.SoftSide",
  },
  {
    logo: facebook,
    link: "https://www.facebook.com/people/SoftSide/100095187117238/",
    linkName: "Facebook.SoftSide",
  },
];

const cardData = [
  {
    icon: result1,
    subheading: "Better Website Experience",
    text: "Redesigning the site improved mobile responsiveness, simplified navigation and reduced bounce rate by 40%, leading to longer sessions and a more confident buyer journey for high-intent visitors.",
  },
  {
    icon: result2,
    subheading: "Consistent Brand Presence",
    text: "Across Instagram, Facebook, LinkedIn and Pinterest, we maintained a clean, cohesive brand voice that increased engagement and built stronger trust, helping the product stand out in the wellness space.",
  },
  {
    icon: result3,
    subheading: "High-Ticket Lead Generation",
    text: "By handling Derwin Hunt’s LinkedIn outreach, we generated qualified leads, improved sales conversations and built a direct connection with premium clientele interested in bulk or retail opportunities.",
  },
];

const project = [
  {
    name: "TanskandCovers",
    img: tanks,
    link: "/case-study/tanksandcover",
  },
  {
    name: "AesRecruitment",
    img: aes,
    link: "/case-study/aes",
  },
  {
    name: "Global Growth Partners",
    img: ggp,
    link: "/case-study/ggp",
  },
];
const SoftSide = () => {
  useEffect(() => {
    // Set Page Title
    document.title = "E-commerce Marketing Case Study | TechQilla";

    // --- Description ---
    let metaDescription = document.querySelector<HTMLMetaElement>(
      "meta[name='description']",
    );
    if (!metaDescription) {
      metaDescription = document.createElement("meta");
      metaDescription.name = "description";
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute(
      "content",
      "Discover how TechQilla helped Softside grow through e-commerce optimization, digital marketing, and conversion strategies.",
    );

    // --- Keywords ---
    let metaKeywords = document.querySelector<HTMLMetaElement>(
      "meta[name='keywords']",
    );
    if (!metaKeywords) {
      metaKeywords = document.createElement("meta");
      metaKeywords.name = "keywords";
      document.head.appendChild(metaKeywords);
    }
    metaKeywords.setAttribute("content", "E-commerce Marketing Case Study");
    // --- Canonical ---
    let linkTag = document.querySelector<HTMLLinkElement>(
      "link[rel='canonical']",
    );
    if (!linkTag) {
      linkTag = document.createElement("link");
      linkTag.rel = "canonical";
      document.head.appendChild(linkTag);
    }
    linkTag.setAttribute(
      "href",
      "https://www.techqilla.com/case-study/softside",
    );
  }, []);

  return (
    <div className="pt-[100px] lg:pt-[80px]">
      <CaseHero
        name="Softside"
        highlited="Softside"
        title="Case Study for"
        icon={icon}
        subtitle="Website Design and Development, Branding "
        date={2024}
        className=""
      />
      <Task
        rows={tableData}
        bgColor="bg-[#2B5F71]" // Custom background color
        headerColor="bg-[#5C9F8E]" // Custom header color
        className=""
        text1="Softside by Hunt offers a simple yet powerful solution - a luxury bathtub cushion designed for deep relaxation. But despite the product’s value, the brand lacked a compelling digital presence, strategic lead generation and a content system that could position it in front of the right clientele.
        <br/>
        <br/>
        The founder Derwin Hunt needed more than traction, he needed direction, visibility and qualified leads."
      />
      <Task1
        heading="Website Design & Development"
        text="We began with a detailed website revamp process which included:"
        list={task1Data}
        listcolor="text-[#2B5F71]"
        listStyleColor="fill-[#2B5F71]"
      />
      <Design
        heading="Website Design"
        bgcolor="bg-[#2B5F71]"
        img={website}
        link="https://www.softsidebyhunt.com/"
        linkName="www.softsidebyhunt.com"
      />
      <Task1
        heading="Social Media Handling"
        text="We managed content and strategy across Instagram, Facebook and LinkedIn to strengthen brand identity and attract high-intent audiences."
        list={task2Data}
        listcolor="text-[#2B5F71]"
        listStyleColor="fill-[#2B5F71]"
      />
      <Work
        bgColor="bg-[#2B5F71]"
        heading="Social Media Creatives"
        img={images}
        link={linkData}
        grid="lg:grid-cols-4"
      />
      <Result
        cardColor="bg-[#2B5F71]"
        heading="Results"
        text="Here’s what changed after we stepped in "
        cards={cardData}
      />
      <OtherProject project={project} />
      <Data />
    </div>
  );
};

export default SoftSide;
